import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';

// API Documentation pages
import ApiDocs from './pages/api-docs/ApiDocs';
import ApiDocsOverview from './pages/api-docs/pages/Overview';
import ApiDocsAuth from './pages/api-docs/pages/Authentication';
import ApiDocsSplits from './pages/api-docs/pages/Splits';
import ApiDocsTransactions from './pages/api-docs/pages/Transactions';
import ApiDocsWallets from './pages/api-docs/pages/Wallets';
import ApiDocsErrors from './pages/api-docs/pages/ErrorCodes';
import ProtectedDocsRoute from './components/routing/ProtectedDocsRoute';

/**
 * DocsApp Component
 * Handles routing for the documentation subdomain (doc.wesplit.io)
 * Only shows API documentation routes with clean URLs (no /api-docs prefix)
 * All routes are protected and require partnership request submission
 */
function DocsApp() {
  return (
    <Router>
      <div className="App">
        <Routes>
          {/* Root shows overview directly - PROTECTED */}
          <Route path="/" element={<ProtectedDocsRoute><ApiDocsOverview /></ProtectedDocsRoute>} />
          
          {/* Clean API Documentation routes (without /api-docs prefix) - ALL PROTECTED */}
          <Route path="/overview" element={<ProtectedDocsRoute><ApiDocsOverview /></ProtectedDocsRoute>} />
          <Route path="/authentication" element={<ProtectedDocsRoute><ApiDocsAuth /></ProtectedDocsRoute>} />
          <Route path="/splits" element={<ProtectedDocsRoute><ApiDocsSplits /></ProtectedDocsRoute>} />
          <Route path="/transactions" element={<ProtectedDocsRoute><ApiDocsTransactions /></ProtectedDocsRoute>} />
          <Route path="/wallets" element={<ProtectedDocsRoute><ApiDocsWallets /></ProtectedDocsRoute>} />
          <Route path="/error-codes" element={<ProtectedDocsRoute><ApiDocsErrors /></ProtectedDocsRoute>} />
          
          {/* Legacy routes with /api-docs prefix - redirect to clean URLs */}
          <Route path="/api-docs" element={<Navigate to="/" replace />} />
          <Route path="/api-docs/overview" element={<Navigate to="/" replace />} />
          <Route path="/api-docs/authentication" element={<Navigate to="/authentication" replace />} />
          <Route path="/api-docs/splits" element={<Navigate to="/splits" replace />} />
          <Route path="/api-docs/transactions" element={<Navigate to="/transactions" replace />} />
          <Route path="/api-docs/wallets" element={<Navigate to="/wallets" replace />} />
          <Route path="/api-docs/error-codes" element={<Navigate to="/error-codes" replace />} />
          
          {/* Catch all - redirect to root (overview) */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </div>
    </Router>
  );
}

export default DocsApp;
